// invoice-taxes — cross-app fiscal tax-pick, promoted to base-lib
// (maintainability 3.2 Cluster A). Body copied VERBATIM from medical
// app/lib/invoice-builder.js pickInvoiceTaxes to preserve fiscal output.
// Do NOT "fix" the preserved behavior here.

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — fiscal tax-pick for invoices (iva_rate/iva_natura/
 *              ritenuta), promoted cross-app from medical
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      no addon imports (pure function)
 *   siblings:  -
 *   tests:     tests/unit/lib/invoice-taxes-test.js
 *   gotchas:   fiscal logic copied VERBATIM from medical's
 *              invoice-builder.js — do not "fix" the preserved behavior;
 *              `gated` must be false for ungated callers (flag #3); guards
 *              `userTaxes` being non-array/undefined (new invoice with no
 *              `user` yet) to avoid killing the invoice-generation task.
 */

/**
 * pickInvoiceTaxes(userTaxes, optionField, { gated }) → { iva_rate, iva_natura, ritenuta }.
 * `gated` controls the default_invoice_nouser check. Ungated callers pass gated:false
 * (flag #3). Tax-pick logic copied verbatim from the PR task body.
 */
function pickInvoiceTaxes(userTaxes, optionField, {
  gated
} = {}) {
  const result = {};
  if (gated && optionField?.default_invoice_nouser) {
    return result;
  }

  // Guard (no fiscal-behavior change): a freshly created invoice may have no
  // `user` yet, so callers can pass undefined. `undefined.find` would kill the
  // whole invoice-generation task after the modal is already open, leaving an
  // empty invoice with no lines. Absent taxes → same result as no matches.
  if (typeof userTaxes?.find !== 'function') {
    return result;
  }
  const iva_rate = userTaxes.find(item => item.is_iva === true);
  if (iva_rate) {
    result.iva_rate = iva_rate.rate;
    result.iva_natura = iva_rate.iva_natura;
  }
  const is_ritenuta = userTaxes.find(item => item.is_ritenuta === true);
  if (is_ritenuta && is_ritenuta.is_active_default) {
    result.ritenuta = true;
  }
  return result;
}

export { pickInvoiceTaxes };
//# sourceMappingURL=invoice-taxes.js.map
